import { isMain } from '@/utils/tools'
// 课前任务讨论
let Discuss = () => import ( /* webpackChunkName: "group-discuss" */ '@/views/course2/discuss/index');
// 项目一任务一
let Project1_2_task1 = () => import ( /* webpackChunkName: "group-project1_2_task1" */ '@/views/course2/project1_2_task1/index');
// 项目一任务二
let Project1_2_task2 = () => import ( /* webpackChunkName: "group-project1_2_task2" */ '@/views/course2/project1_2_task2/index');
// 项目二任务一
let Project2_2_task1 = () => import ( /* webpackChunkName: "group-project2_2_task1" */ '@/views/course2/project2_2_task1/index');
// 项目二任务二
let Project2_2_task2 = () => import ( /* webpackChunkName: "group-project2_2_task2" */ '@/views/course2/project2_2_task2/index');
// 项目三任务一
let Project3_2_task1 = () => import ( /* webpackChunkName: "group-project3_2_task1" */ '@/views/course2/project3_2_task1/index');
// 项目四任务一
let Project4_2_task1 = () => import ( /* webpackChunkName: "group-project4_2_task1" */ '@/views/course2/project4_2_task1/index');
// 项目四任务二
let Project4_2_task2 = () => import ( /* webpackChunkName: "group-project4_2_task2" */ '@/views/course2/project4_2_task2/index');
// 项目五任务一
let Project5_2_task1 = () => import ( /* webpackChunkName: "group-project5_2_task1" */ '@/views/course2/project5_2_task1/index');
// ------------------------------------------------------------
// 上线判断

if(!isMain()) {
   
}

export default [
    {
        path: '/discuss',
        name: '',
        component:Discuss ,
    },
    {
        path: '/project1_2_task1',
        name: '',
        component: Project1_2_task1
    },
    {
        path: '/project1_2_task2',
        name: '',
        component: Project1_2_task2
    },
    {
        path: '/project2_2_task1',
        name: '',
        component: Project2_2_task1
    },
    {
        path: '/project2_2_task2',
        name: '',
        component: Project2_2_task2
    },
    {
        path: '/project3_2_task1',
        name: '',
        component: Project3_2_task1
    },
    {
        path: '/project4_2_task1',
        name: '',
        component: Project4_2_task1
    },
    {
        path: '/project4_2_task2',
        name: '',
        component: Project4_2_task2
    },
    {
        path: '/project5_2_task1',
        name: '',
        component: Project5_2_task1
    }
];